module.exports = __webpack_public_path__ + "img/xinhao.288b0d14.png";